import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { YearService } from '../../../../shared-components/year/year.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { AccomodationBank } from '../../../sped-management/sped-management.model';
import { SpedManagementService } from '../../../sped-management/sped-management.service';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { IdentificationSubCodes, PickIdentification } from '../../formwithin-document-modal';

@Component({
  selector: 'app-pick-identification-maintenance',
  templateUrl: './pick-identification-maintenance.component.html',
  styleUrls: ['./pick-identification-maintenance.component.css']
})
export class PickIdentificationMaintenanceComponent implements OnInit {
  dialogTitle = '';
  getIdentificationData: AccomodationBank[] = [];
  tylerMatData = new TylerMatTableDataSource();
  selectedMasterDescription: string;
  stateCode: string;
  selectedDataId: number;
  dualSelectedDataId: number;
  selectedIdenticationCodes: string;
  tertiarySelectedDataId = 0;
  quaternarySelectedDataId = 0;
  fifthSelectedDataId = 0;
  getIdentificationSubCodeGrid: IdentificationSubCodes[] = [];
  xmlValue: PickIdentification[] = [];
  xmlIdentificationCode: PickIdentification[] = [];
  xmlDualIdentificationCode: PickIdentification[] = [];
  xmlTertiaryIdentificationCode: PickIdentification[] = [];
  xmlQuaternaryIdentificationCode: PickIdentification[] = [];
  xmlFifthIdentificationCode: PickIdentification[] = [];
  xmlValuesingle = new PickIdentification();
  yearId: number;
  columnToDisplay = ['Code', 'Description'];
  selectedCode: string;
  studentXMLDataId: number;


  constructor(private formWithinDocumentsService: FormWithinDocumentsService,
    private spedManagementService: SpedManagementService,
    private matDialogRef: MatDialogRef<PickIdentificationMaintenanceComponent>,
    private loginService: LoginService,
    private yearService: YearService) { }

  ngOnInit(): void {
    this.yearId = this.yearService.defaultYear.Id;
    this.stateCode = this.loginService.LoginSettings.State;
    if (this.stateCode == 'MO') {
      this.selectedMasterDescription = 'Identification/Dual Identification Codes';
    }
    else if (this.stateCode == 'IL') {
      this.selectedMasterDescription = 'Identification Codes';
    }
    else if (this.stateCode == 'NM' || this.stateCode == 'OR') {
      this.selectedMasterDescription = 'Identification/Dual Identification Codes';
    }
    this.getXmlCode();
  }

  closeClick() {
    this.checkOutForm();
    this.matDialogRef.close();
  }

  getIdentificationDropDown() {
    this.spedManagementService.getIdentificationCode(this.selectedMasterDescription).subscribe(subCodes => {
      this.getIdentificationData = subCodes;
      if (this.xmlIdentificationCode.length == 0) {
        this.selectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      }
      else {
        this.checkSelectedValues();
      }
      if (this.xmlDualIdentificationCode.length == 0) {
        this.dualSelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      }
      else {
        this.checkSelectedValues();
      }
      if (this.xmlTertiaryIdentificationCode.length == 0) {
        this.tertiarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      }
      else {
        this.checkSelectedValues();
      }
      if (this.xmlQuaternaryIdentificationCode.length == 0) {
        this.quaternarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      }
      else {
        this.checkSelectedValues();
      }
      if (this.xmlFifthIdentificationCode.length == 0) {
        this.fifthSelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      } else {
        this.checkSelectedValues();
      }
    });
  }

  checkSelectedValues() {
    if (this.xmlIdentificationCode.length != 0) {
      let getdataId: AccomodationBank[] = [];
      getdataId = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].IdentificationCode);
      this.selectedDataId = JSON.parse(JSON.stringify(getdataId[0].DataId));

    }
    if (this.xmlDualIdentificationCode.length != 0) {
      let dualCode: AccomodationBank[] = [];
      dualCode = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].DualIdentificationCode);
      this.dualSelectedDataId = JSON.parse(JSON.stringify(dualCode[0].DataId));
    }

    if (this.stateCode == 'NM') {
      this.xmlValue.forEach(obj => {
        if (obj.TertiaryIdentificationCode == '') {
          this.tertiarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
          this.fifthSelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
        }
        else {
          let tertiaryCode: AccomodationBank[] = [];
          tertiaryCode = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].TertiaryIdentificationCode);
          this.tertiarySelectedDataId = JSON.parse(JSON.stringify(tertiaryCode[0].DataId));
        }
        if (obj.QuaternaryIdentificationCode == '') {
          this.quaternarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
        }
        else {
          let quaternaryCode: AccomodationBank[] = [];
          quaternaryCode = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].QuaternaryIdentificationCode);
          this.quaternarySelectedDataId = JSON.parse(JSON.stringify(quaternaryCode[0].DataId));
          this.getDroDownGrid();
        }
      });
    }
    else if (this.stateCode == 'OR') {
      this.xmlValue.forEach(obj => {
        if (obj.TertiaryIdentificationCode == '') {
          this.tertiarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
        }
        else {
          let tertiaryCode: AccomodationBank[] = [];
          tertiaryCode = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].TertiaryIdentificationCode);
          this.tertiarySelectedDataId = JSON.parse(JSON.stringify(tertiaryCode[0].DataId));
          this.getDroDownGrid();
        }
        if (obj.QuaternaryIdentificationCode == '') {
          this.quaternarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
        } else {
          let quaternaryCode: AccomodationBank[] = [];
          quaternaryCode = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].QuaternaryIdentificationCode);
          this.quaternarySelectedDataId = JSON.parse(JSON.stringify(quaternaryCode[0].DataId));
          this.getDroDownGrid();
        }
        if (obj.FifthIdentificationCode == '') {
          this.fifthSelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
        } else {
          let fifthCode: AccomodationBank[] = [];
          fifthCode = this.getIdentificationData.filter(x => x.Code == this.xmlValue[0].FifthIdentificationCode);
          this.fifthSelectedDataId = JSON.parse(JSON.stringify(fifthCode[0].DataId));
          this.getDroDownGrid();
        }
        //  }
      });
    }
    else {
      this.tertiarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      this.quaternarySelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      this.fifthSelectedDataId = JSON.parse(JSON.stringify(this.getIdentificationData[0].DataId));
      this.getDroDownGrid();
    }
  }

  dropDownChange() {
    this.formWithinDocumentsService.pickIdentificationData.IdentificationId = this.selectedDataId;
    this.formWithinDocumentsService.pickIdentificationData.IdentificationCode = this.getIdentificationData.find(x => x.DataId == this.selectedDataId).Code;
    this.formWithinDocumentsService.pickIdentificationData.IdentificationDesc = this.getIdentificationData.find(x => x.DataId == this.selectedDataId).Description;
    this.formWithinDocumentsService.pickIdentificationData.DualIdentificationId = this.dualSelectedDataId;
    this.formWithinDocumentsService.pickIdentificationData.DualIdentificationCode = this.getIdentificationData.find(x => x.DataId == this.dualSelectedDataId).Code;
    this.formWithinDocumentsService.pickIdentificationData.DualIdentificationDesc = this.getIdentificationData.find(x => x.DataId == this.dualSelectedDataId).Description;
    this.formWithinDocumentsService.pickIdentificationData.TertiaryIdentificationId = this.tertiarySelectedDataId;
    this.formWithinDocumentsService.pickIdentificationData.TertiaryIdentificationCode = this.getIdentificationData.find(x => x.DataId == this.tertiarySelectedDataId).Code;
    this.formWithinDocumentsService.pickIdentificationData.TertiaryIdentificationDesc = this.getIdentificationData.find(x => x.DataId == this.tertiarySelectedDataId).Description;
    this.formWithinDocumentsService.pickIdentificationData.QuaternaryIdentificationId = this.quaternarySelectedDataId;
    this.formWithinDocumentsService.pickIdentificationData.QuaternaryIdentificationCode = this.getIdentificationData.find(x => x.DataId == this.quaternarySelectedDataId).Code;
    this.formWithinDocumentsService.pickIdentificationData.QuaternaryIdentificationDesc = this.getIdentificationData.find(x => x.DataId == this.quaternarySelectedDataId).Description;
    this.formWithinDocumentsService.pickIdentificationData.FifthIdentificationId = this.fifthSelectedDataId;
    this.formWithinDocumentsService.pickIdentificationData.FifthIdentificationCode = this.getIdentificationData.find(x => x.DataId == this.fifthSelectedDataId).Code;
    this.formWithinDocumentsService.pickIdentificationData.FifthIdentificationDesc = this.getIdentificationData.find(x => x.DataId == this.fifthSelectedDataId).Description;
    this.getDroDownGrid();
  }
  getDroDownGrid() {
    this.formWithinDocumentsService.spedTemplateFieldsRead(this.selectedDataId, this.dualSelectedDataId, this.tertiarySelectedDataId, this.quaternarySelectedDataId, this.fifthSelectedDataId).subscribe(data => {
      this.getIdentificationSubCodeGrid = data;
      this.tylerMatData = new TylerMatTableDataSource(this.getIdentificationSubCodeGrid);
      this.tylerMatData.data = this.getIdentificationSubCodeGrid;
    });
  }

  saveClick() {
    this.formWithinDocumentsService.saveIdentificationData(this.yearId).subscribe(() => {
      this.closeClick();
    });
  }

  getXmlCode() {
    this.formWithinDocumentsService.getXMLCodesvalues(this.yearId).subscribe(xmlData => {
      this.xmlValue = xmlData;
      const xmltempidentification = this.xmlValue;
      const xmldualValue = this.xmlValue;
      const xmlTertiary = this.xmlValue;
      const xmlQuaternary = this.xmlValue;
      const xmlFifthValue = this.xmlValue;
      this.xmlIdentificationCode = xmltempidentification.filter(x => x.IdentificationCode != '');
      this.xmlDualIdentificationCode = xmldualValue.filter(x => x.DualIdentificationCode != '');
      this.xmlTertiaryIdentificationCode = xmlTertiary.filter(x => x.TertiaryIdentificationCode != '');
      this.xmlQuaternaryIdentificationCode = xmlQuaternary.filter(x => x.QuaternaryIdentificationCode != '');
      this.xmlFifthIdentificationCode = xmlFifthValue.filter(x => x.FifthIdentificationCode != '');
      this.getIdentificationDropDown();
    });
  }

  checkOutForm() {
    this.formWithinDocumentsService.checkOutForm(this.studentXMLDataId, this.formWithinDocumentsService.spedStudentCollectionTemplate.CheckOutByUserId, false).subscribe(() => {
    });
  }

}